// extracted by mini-css-extract-plugin
export default {"container":"Payment-module--container--fb952","form":"Payment-module--form--741eb","button":"Payment-module--button--f84ef"};